import {OxygenError} from '../types.js';

export const BuildInitiateQuery = `
  mutation BuildInitiate($environment: EnvironmentSelectorInput, $labels: [String!]) {
    buildInitiate(environment: $environment, labels: $labels) {
      build {
        id
        assetPath
      }
      userErrors {
        message
      }
    }
  }
`;

export interface BuildInitiateQueryData {
  buildInitiate: BuildInitiateResponse;
}

export interface BuildInitiateResponse {
  build: {
    id: string;
    assetPath: string;
  };
  userErrors: OxygenError[];
}
